import type { Aggregation, RuleParam } from '@/entities/pricing-rule'

import { useTranslation } from 'react-i18next'

import {
	AGGREGATION_LABELS,
	aggregationOptionsFor,
} from '@/entities/pricing-rule'

import { RHFSelect } from '@/shared/components/HookForm'

/** Special param type: aggregation chosen from the rule's catalog. */
export const AggregationTypeField = ({
	name,
	label,
	testId,
	param,
}: {
	name: string
	label: string
	testId?: string
	param: Pick<RuleParam, 'options'>
}) => {
	const { t } = useTranslation()
	const options = aggregationOptionsFor(param).map((value) => ({
		value,
		// A rule may declare an aggregation outside the catalog (e.g. the legacy
		// `average` spelling) — fall back to the raw value for those.
		label: t(value, {
			defaultValue: AGGREGATION_LABELS[value as Aggregation] ?? value,
		}),
	}))

	return (
		<RHFSelect
			name={name}
			label={label}
			options={options}
			testId={testId}
			placeholder={t('general_select', {
				defaultValue: 'Select',
			})}
		/>
	)
}
